const MOBILE_DEVICE_WIDTH_CUTOFF = 768;

export function isMobileDevice(): boolean {
  return window.innerWidth <= MOBILE_DEVICE_WIDTH_CUTOFF;
}
